import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import { ContentContainer } from '../../../../components/Layout/ContentContainer';
import { Screen } from '../../../../components/Layout/Screen';
import Title, { Highlight } from '../../../../components/Title';
import TextBlock from '../../../../components/TextBlock';

// Assets
import { brandColors, device } from '../../../../styles/variables';
import room5 from '../../../../assets/images/pages/bridging-the-gap/room5yellow.png';

const StyledScreen = Screen.extend`
  position: relative;
  overflow: hidden;
  background: ${brandColors.purple};
  padding-top: 1px;
  margin-top: -1px;

  .title {
    padding: 156px 0 0;
    max-width: 210px;
  }
`;

const Content = ContentContainer.extend`
  position: relative;
`;

const ImagePosition = styled.div`
  max-width: 388px;

  @media ${device.mobileL} {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    right: -43%;
    max-width: 500px;
  }

  @media ${device.tablet} {
    right: -36%;
    max-width: 688px;
  }

  @media ${device.laptop} {
    right: -30%;
    max-width: 928px;
  }
`;

const BeautifullyEmotiveScreen = () => (
  <StyledScreen>
    <Content>
      <Title primary={false} className="title" color={brandColors.white}>
        Beautifully <Highlight>emotive</Highlight>
      </Title>
      <br />
      <TextBlock width="380px" color={brandColors.white}>
        <p>
          As well as the patient animations and panel discussions, the program also features
          instructional animations, filmed demonstrations, and an interactive guide to visual aids,
          which together create a hugely valuable resource awarded 2 CET points.
        </p>
      </TextBlock>
      <ImagePosition>
        <img src={room5} alt="Bridging the gap" />
      </ImagePosition>
    </Content>
  </StyledScreen>
);

export default connect()(BeautifullyEmotiveScreen);



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/BridgingTheGap/screens/BeautifullyEmotive.jsx